import axios from 'axios';
import getConfig from 'next/config';
import { getKeycloakInstance } from '@react-keycloak-fork/ssr';
import {
    createUser,
    getUser,
    updateUser,
    deleteUser,
    updateUserData,
    verifyEmail,
    retryEmailVerification,
    updateUserAffiliation,
    removeUserAffiliation,
    updateUserPreferences,
    fetchKreditdata,
    fetchPartnerKreditdata,
    saveKreditdataPensionPdf,
    saveKreditdataBudgetPdf,
    inviteUserToKreditdata,
    invitePartnerToKreditdata,
    getPensionAnalysis,
} from './users';
import { getAffiliate, getAffiliates, getAffiliateBySlug, getAffiliateByAffiliateCode,getAffiliateProduct } from './affiliates';

import { getProduct, getProductBySlug } from './products';
import { getAllSharings, getSharing, acceptSharing, rejectSharing, revokeSharing, renewSharing, createSharing } from './sharings';
import { sendTellAFriendMail, signupForThePenlyPanel, emailTestAll, signupForInvestTjekEmailNotification, contactPenly } from './email';
import { getBookingAvailability, saveBooking } from './advisory';
import { getPropertyData } from './properties';
import { updateAndGetMortgageCheckResult } from './mortgageCheck/mortgageCheckAPI';


const { publicRuntimeConfig } = getConfig();
const anonymousRequest = axios.create({ baseURL: publicRuntimeConfig.apiUrl });
const request = axios.create({ baseURL: publicRuntimeConfig.apiUrl });

request.interceptors.request.use(async config => {
    const { token } = getKeycloakInstance();
    config.headers.Authorization = `Bearer ${token}`; // eslint-disable-line no-param-reassign
    return config;
});

/* Users */
export {
    createUser,
    getUser,
    updateUser,
    deleteUser,
    updateUserData,
    verifyEmail,
    retryEmailVerification,
    updateUserAffiliation,
    removeUserAffiliation,
    updateUserPreferences,
    fetchKreditdata,
    fetchPartnerKreditdata,
    saveKreditdataPensionPdf,
    saveKreditdataBudgetPdf,
    inviteUserToKreditdata,
    invitePartnerToKreditdata,
    getPensionAnalysis,
};
/* Affiliates */
export { getAffiliate, getAffiliates, getAffiliateBySlug, getAffiliateByAffiliateCode,getAffiliateProduct };

/* Products */
export { getProduct, getProductBySlug };

/* Sharings */
export { getAllSharings, getSharing, acceptSharing, rejectSharing, revokeSharing, renewSharing, createSharing };

/* Email */
export { sendTellAFriendMail, signupForThePenlyPanel, emailTestAll, signupForInvestTjekEmailNotification, contactPenly };


/* Advisory */
export { getBookingAvailability, saveBooking };

/* Misc */
export async function updateContent({ fileId, content }) {
    const { data } = await request.put(`/user/files/${fileId}`, { file: { content } });
    return data;
}
export async function createMessage(messageData) {
    const {
        data: { message },
    } = await request.post('/user/conversations/messages', messageData);
    return message;
}

/* Properties */
export { getPropertyData, updateAndGetMortgageCheckResult };

export async function resetPassword() {
    getKeycloakInstance().login({
        action: 'UPDATE_PASSWORD',
        redirectUri: `${window.location.origin}/mit-penly/profil/indstillinger/sikkerhed`,
    });
}

export async function sendSurveyResponse(actionToken, response) {
    await anonymousRequest.post('/user/survey', { actionToken, response });
}

export async function unsubscribe({ email, actionToken }) {
    if (actionToken) {
        try {
            await anonymousRequest.post('/user/unsubscribe-info-mails', { actionToken });
        } catch (error) {
            if (error.response.status === 404 && error.response.data.code === 'InvalidActionToken') return false;
            throw new Error('Error while trying to unsubscribe with token', { cause: error });
        }
        return true;
    }
    if (email) {
        try {
            await anonymousRequest.post('/email/unsubscribe', { email });
        } catch (error) {
            if (error.response.status === 404 && error.response.data.code === 'SubscriberNotFound') return false;
            throw new Error('Error while trying to unsubscribe with email', { cause: error });
        }
        return true;
    }
}

/* Teal Calculation API */
export async function pensionHistory({ scrapes, userId }) {
    // This is a stub implementation as before
    console.log('pension history');
    return { 'result': null, 'performanceMeasurement': null };
}

export async function pensionAnalysis(body) {
    const response = await request.post(
        '/user/analyse/pension',
        body,
        {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    );
    return response.data;
}

export async function pensionAnalysisKlatpension(body) {
    const response = await request.post(
        '/user/analyse/klatpension',
        body,
        {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    );
    return response.data;
}

export async function calculatePaymentAndPrognosis(calculationValues) {
    const response = await request.post(
        '/user/analyse/calculatePaymentAndPrognosis',
        calculationValues,
        {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
    return response.data;
}

export async function calculatePensionYearAndPrognosis(calculationValues) {
    const response = await request.post(
        '/user/analyse/calculatePensionYearAndPrognosis',
        calculationValues,
        {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
    return response.data;
}
